import React from "react";
import { useNavigate } from "react-router-dom";




const Pricing =()=>{
    const navigate = useNavigate();

const scrollToTop = (location) => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(location)
  };

return (
    <div className="pricing-css">
    <h2 className="module-title" id="title-margin">Pricing Packages</h2>

<ul className="pricing-table">
       <ul  >
        <li className="individual-li-title" id="title-orange">
            <h2 className="pricing-title">PC License</h2>
        </li>

        <li className="individual-li">
        <p className="pricing-text">Life-Saving Rules Aware ™ <span className="price">   $10 / Per User </span> </p>
            <p className="pricing-text">Life-Saving Rules Pro ™ <span className="price">   $30 / Per User </span> </p>

            <p className="pricing-text">Life-Saving Rules Road ™<span className="price">$30 / Per User </span></p>

            <p className="pricing-text-bold">Life-Saving Rules Bundle <span className="price">   $60 /  3 Trainings  </span> </p>

            <p className="pricing-text">Driving Aware All roads ™
            <span className="price"> $15 / Per User </span> </p>

            <p className="pricing-text">Driving Pro Black Top ™
                        <span className="price">   $25 / Per User </span> </p>

            <p className="pricing-text">Driving Pro Graded Road ™
                        <span className="price">   $30 / Per User </span> </p>
            <p className="pricing-text-bold">Driving Safety Bundle <span className="price">   $65 /  3 Trainings  </span> </p>

            <p className="pricing-text">Process Safety
            <span className="price">   $50 / Per User </span> </p>
            <button className="price-button" id ="button-orange" onClick={()=>scrollToTop('/pclicense')}>Purchase PC License</button>
        </li>
       </ul>


        {/* <ul className="gaps">
        <li className="individual-li-title" id="title-orange">
            <h2>VR License  </h2>
        </li>

        <li className="individual-li">

        <p className="pricing-text">Life-Saving Rules Aware ™ <span className="price">  $15 /  Per User </span> </p>
            <p className="pricing-text">Life-Saving Rules Pro ™ <span className="price">  $45 /  Per User </span> </p>
            <p className="pricing-text">Life-Saving Rules Road ™<span className="price"> $45 /  Per User </span></p>

            <p className="pricing-text-bold">Life-Saving Rules Bundle <span className="price">   $100 /  3 Trainings  </span> </p>
            <p className="pricing-text">Driving Aware All roads ™ <span className="price">   $20 /  Per User </span> </p>

            <p className="pricing-text">Driving Pro Black Top ™<span className="price">   $40 /  Per User </span> </p>
            <p className="pricing-text">Driving Pro Graded Road ™<span className="price">   $50 /  Per User </span> </p>
            <p className="pricing-text-bold">Driving Safety Bundle <span className="price">   $100 / 3 Trainings  </span> </p>

            <p className="pricing-text">Process Safety <span className="price">   $100 /  Per User </span> </p>

        <button className="price-button" id ="button-orange" onClick={()=>scrollToTop('/vrlicense')}>Purchase VR License</button>

        </li>
       </ul> */}


{/* ---------------------------------------- */}


</ul>



<div className="table-bottom">
    <div className = "top-title">
        <h2 className="title-background"> Why Choose us?</h2>
    </div>


    <ul>
        <li className="bottom-badges">

        <span className="blue-text"> <img src="/mainImages/icons/save.png" alt="Life-Saving Rules Aware"className="price-image" />
            Save More with Business Plans </span>
        <span className="blue-text"> <img src="/mainImages/icons/flexible-training-options.png" alt="Life-Saving Rules Pro"className="price-image" />
            Flexible Training Options</span>
        <span className="blue-text"> <img src="/mainImages/icons/scalableadaptable.png" alt="Life-Saving Rules Road"className="price-image" />
            Scalable and Adaptable</span>
        </li>
        <li className="bottom-copy">
            <p className="text-line"><span className="orange-text">Discount</span> for companies on the purchase of 10 or more licenses.</p>
            <p className="text-line">Whether you are a small team or a large corporation, our packages are designed to your need and budget. </p>
            <p className="text-line">Our packages grow with your organization add more users, games, or features as needed! </p>
        </li>
    </ul>
</div>

<p className="small-text"> All PC licenses are valid for a duration of 30 days from date of purchase with 10 game runs per game</p>


</div>
)
}

export default Pricing;
